<template>
  <div
    :class="[`section_${id}`, currentView, { active: isActive(id) }, { hidden: !options.visible }]"
    :style="style"
    v-indicator="{ id, setActive }"
  >
    <button
      class="button"
      style="color: black;"
      v-if="shouldPaste"
      @click.stop="pastePanel({ id: panelCopied, parentId: id })"
    >
      <i class="fas fa-paste"></i>
    </button>

    <div v-html="styleCss"></div>

    <div class="information">{{ info }}<i class="fas fa-hand-pointer" @click.stop="setActive(id)"></i></div>

    <i class="fas fa-plus-circle plus-icon" v-if="!current.children.length"></i>
    <div :class="['container', { 'full-width': options.fullWidth }]" :style="containerStyle">
      <Panel v-for="child in current.children" :key="child" :id="child" :childrenOfActive="isActive(id)" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Panel from '@/components/page-editor/Panel'
import Mixin from '@/components/page-editor/Mixin.js'

export default {
  name: 'Section',
  mixins: [Mixin],
  components: { Panel },
  computed: {
    ...mapState('landing', ['panelCopied']),
    style() {
      return {
        backgroundImage: this.getBackgroundImageOrder,
        order: this.options.position,
        alignSelf: this.options.selfAlign.vertical,
        justifySelf: this.options.selfAlign.horizontal,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    },
    getBackgroundImageOrder() {
      if (this.options.background.isImagePriority) {
        return `url(${this.options.background.url}),
        linear-gradient(
          ${this.options.background.color},
          ${this.options.background.color}
        )`
      }
      return `
        linear-gradient(
          ${this.options.background.color},
          ${this.options.background.color}
        ), url(${this.options.background.url})`
    },
    styleCss() {
      return `<style>${this.options.style.css}</style>`
    },
    containerStyle() {
      return {
        alignItems: this.options.align.vertical,
        justifyContent: this.options.align.horizontal,
        paddingTop: `${this.options.padding.top}px`,
        paddingRight: `${this.options.padding.right}px`,
        paddingBottom: `${this.options.padding.bottom}px`,
        paddingLeft: `${this.options.padding.left}px`,
      }
    },
    info() {
      const panels = this.current.children.length
      const info = panels
        ? `${panels} ${this.$i18n.t('components.page-editor.section.panel/panels')}`
        : this.$i18n.t('components.page-editor.section.empty')
      return `${this.current.title}${info && ` - ${info}`}`
    },
    shouldPaste() {
      return this.isActive(this.id) && this.panelCopied
    },
  },
}
</script>

<style lang="scss" scoped>
[class^='section_'] {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-size: cover;
  position: relative;
  width: 100%;
  overflow: hidden;

  .button {
    position: absolute;
    background: white;
    left: 4px;
    top: 4px;
    border: 1px solid #ddd;
    border-radius: 5px;
    outline: none;
    cursor: pointer;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
  }

  > .information {
    display: none;
    position: absolute;
    bottom: 0px;
    right: 0px;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    z-index: 1;
    background: var(--indicator-active);
    cursor: pointer;
  }

  &:hover,
  &.active {
    box-shadow: inset 0 0 0px 2px var(--indicator-active);
    > .information {
      display: block;
    }
  }

  > .container {
    display: flex;
    flex-wrap: wrap;
    max-width: 940px;
    width: 100%;

    &.full-width {
      max-width: unset;

      [class^='panel_'] {
        /deep/ .container {
          margin: 0;
          max-width: 100%;
        }
      }
    }

    &:empty {
      height: 100px;
      border: 2px dashed rgb(199, 199, 199);
      margin: 10px;
      max-width: calc(100% - 20px) !important;
    }
  }

  .plus-icon {
    top: 45%;
    position: absolute;
    left: 48%;
    color: rgb(199, 199, 199);
  }

  @media screen and (max-width: 1400px) {
    &.lg {
      background-size: 1356px;
      background-position-x: -150px;
    }
  }
}
</style>
